export interface ApiConfig {
    API_URL: string;
    AUTH_URL: string;
}

const win: ApiConfig = {
    API_URL: 'http://localhost:5044',
    AUTH_URL: 'http://localhost:5044/auth'
};

const mac: ApiConfig = {
    API_URL: 'http://localhost:5044',
    AUTH_URL: 'http://localhost:5044/auth'
};

const production: ApiConfig = {
    API_URL: 'https://booking.studioellies.eu',
    AUTH_URL: 'https://booking.studioellies.eu/auth'
};





const environments = {
    win,
    mac,
    production
}

//@ts-ignore
export const apiConfig: ApiConfig = environments[process.env.REACT_APP_STAGE];
